/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { rtkApi } from '@/z-shared/api';
import { CookieKeyEnum, cookieHelper } from '@/app/cookies';
import type { UserData } from '@/z-shared/lib/types/userData';
import { authActions } from '../model/slice/authSlice';
import { logoutUser } from '../model/services/logoutUser';

const authApi = rtkApi.injectEndpoints({
    endpoints: build => ({
        refreshTokens: build.query<Required<UserData>, null>({
            query: () => ({
                url: '/auth/refresh-tokens',
                body: {
                    fingerprint: cookieHelper.get(CookieKeyEnum.FINGERPRINT),
                    refreshToken: cookieHelper.get(CookieKeyEnum.USER_DATA)?.refreshToken,
                },
                method: 'POST',
                credentials: 'include',
            }),
            async onQueryStarted(_, { queryFulfilled, dispatch }) {
                queryFulfilled
                    .then(({ data }) => {
                        cookieHelper.set(CookieKeyEnum.USER_DATA, data);
                        dispatch(authActions.loginUser(data));
                    })
                    .catch(() => dispatch(logoutUser()))
                    .finally(() => dispatch(authActions.initAuth()));
            },
            transformErrorResponse(baseQueryReturnValue) {
                return {
                    showUnathorized: true,
                    ...baseQueryReturnValue,
                };
            },
        }),
    }),
});

export const useRefreshTokens = authApi.useRefreshTokensQuery;
